import type { ElementType, ReactNode } from "react";
import styles from "./DisplayHeading.module.css";

type Size = "sm" | "md" | "lg" | "xl";

interface Props {
  children: ReactNode;
  /** Rendered element. Defaults to h2 — pick the level the outline needs. */
  as?: ElementType;
  size?: Size;
  /** §03 hard violet offset shadow. Hero display type only. */
  shadowed?: boolean;
  className?: string;
  id?: string;
}

/**
 * Anton display type.
 *
 * Uppercase, the -6deg skew and the 32px floor are baked in — a caller cannot
 * opt out, which is the point. There is no `color` prop: display type is --ice,
 * and a heading is never a data surface.
 */
export function DisplayHeading({
  children,
  as: Tag = "h2",
  size = "md",
  shadowed = false,
  className,
  id,
}: Props) {
  const classes = [styles.heading, styles[size], shadowed && styles.shadowed, className]
    .filter(Boolean)
    .join(" ");

  return (
    <Tag className={classes} id={id}>
      {children}
    </Tag>
  );
}
